import React from 'react';

import { formatCents } from '@src/common';
import { PackagePriceContainer, PriceItem } from '../styles';
import useTranslate from '@src/i18n/useTranslate';
import { PriceSummary } from '@src/domains/cart';

const TotalPriceSummary = (props: Readonly<PriceSummary>) => {
  const { previousPrice, discount, total } = props;
  const { i18n } = useTranslate();

  return (
    <PackagePriceContainer>
      {previousPrice && previousPrice !== total ? (
        <PriceItem>
          <p>{i18n('cart_item_price_summary_previous')}: </p>
          <span>{formatCents(previousPrice)}</span>
        </PriceItem>
      ) : null}

      {discount && discount > 0 ? (
        <PriceItem>
          <p>{i18n('cart_discount')}: </p>
          <span>-{formatCents(discount)}</span>
        </PriceItem>
      ) : null}

      <PriceItem>
        <p>{i18n('cart_totalLabel')}: </p>
        <strong>{formatCents(total)}</strong>
      </PriceItem>
    </PackagePriceContainer>
  );
};

export default TotalPriceSummary;
